import { Log } from '../../AuxillaryService/Log';

export interface LogConfigurationInterface {
    /**
     * Method called during signage initialization. Allows the platform to
     * configure the logger with additional logging mechanisms.
     */
    configureLogging(log: Log): Promise<void>;
}

export function supportsLogConfiguration(platform: unknown): platform is LogConfigurationInterface {
    return platform instanceof Object && 'configureLogging' in platform;
}
